import { LanguageStringEnumObj } from "./language/LanguageModel";
export var ErrorCodesObj = {
    AUTH_INVALID: "AUTH_INVALID",
    ACCT_INACCESSIBLE: "ACCT_INACCESSIBLE",
    FRAUD: "FRAUD",
    OTP_SEND_FAILED: "OTP_SEND_FAILED",
    RETRIES_EXCEEDED: "RETRIES_EXCEEDED",
    SESSION_ID_INVALID: "SESSION_ID_INVALID",
    VALDATA_MISSING: "VALDATA_MISSING",
    CODE_INVALID: "CODE_INVALID",
    CODE_EXPIRED: "CODE_EXPIRED",
    CARD_MISSING: "CARD_MISSING",
    CARD_ADD_FAILED: "CARD_ADD_FAILED",
    CARD_SECURITY_CODE_MISSING: "CARD_SECURITY_CODE_MISSING",
    CARD_INVALID: "CARD_INVALID",
    CARD_EXP_INVALID: "CARD_EXP_INVALID",
    CARD_NOT_RECOGNIZED: "CARD_NOT_RECOGNIZED",
    MERCHANT_DATA_INVALID: "MERCHANT_DATA_INVALID",
    UNABLE_TO_CONNECT: "UNABLE_TO_CONNECT",
    NO_INTERNET_CONNECTION: "NO_INTERNET_CONNECTION",
    PROFILE_LOAD_FAILED: "PROFILE_LOAD_FAILED",
    EMPTY_PROFILE_LIST: "EMPTY_PROFILE_LIST",
    TERMS_AND_CONDITIONS_NOT_ACCEPTED: "TERMS_AND_CONDITIONS_NOT_ACCEPTED",
    EMAIL_NOT_DEFINED: "EMAIL_NOT_DEFINED",
    EMAIL_INVALID: "EMAIL_INVALID",
    OTP_EMPTY: "OTP_EMPTY",
    OTP_SEND_FAILED_RESEND: "OTP_SEND_FAILED_RESEND",
    CODE_EXPIRED_SEND: "CODE_EXPIRED_SEND",
    OTP_RESENT: "OTP_RESENT",
    EMPTY_CARD_LIST_HEADER: "EMPTY_CARD_LIST_HEADER",
};
export var SomethingWentWrongErrorCodesObj = {
    REQUEST_TIMEOUT: "REQUEST_TIMEOUT",
    SERVER_ERROR: "SERVER_ERROR",
    INVALID_PARAMETER: "INVALID_PARAMETER",
    INVALID_REQUEST: "INVALID_REQUEST",
    AUTH_ERROR: "AUTH_ERROR",
    NOT_FOUND: "NOT_FOUND",
    SERVICE_ERROR: "SERVICE_ERROR",
    INVALID_ARGUMENT: "INVALID_ARGUMENT",
    INVALID_VALUE: "INVALID_VALUE",
};
export var mapErrorCode = function (errorCode) {
    if (errorCode === undefined)
        return LanguageStringEnumObj.SWW;
    if (typeof errorCode !== "string")
        throw new Error("errorCode must be a string");
    if (Object.values(SomethingWentWrongErrorCodesObj).includes(errorCode))
        return LanguageStringEnumObj.SWW;
    if (Object.values(ErrorCodesObj).includes(errorCode))
        return errorCode;
    return NOT_SUPPORTED_ERROR_CODE;
};
export var NOT_SUPPORTED_ERROR_CODE = "NOT_SUPPORTED_ERROR_CODE";
export var getErrorCode = function (error) { var _a; return typeof error.reason === "string" ? error.reason : (_a = error.reason) === null || _a === void 0 ? void 0 : _a.reason; };
var getDisplayErrorCode = function (errorCode) {
    var mappedErrorCode = mapErrorCode(errorCode);
    return mappedErrorCode === NOT_SUPPORTED_ERROR_CODE ? LanguageStringEnumObj.SWW : mappedErrorCode;
};
export var getErrorInfoMessageString = function (errorsList, languageHandler) {
    var errorCodes = errorsList.map(function (error) { return getDisplayErrorCode(getErrorCode(error)); });
    return Array.from(new Set(errorCodes))
        .filter(function (errorCode) { return Boolean(errorCode); })
        .map(function (errorCode) { return languageHandler.getString(errorCode); })
        .join(", ");
};
